import axiosClient from "../axiosInstance";

const base = "/entries";

const getEntries = async () => {
  return axiosClient.get(base).then((response) => {
    return response.data;
  });
};

const getAllEntriesWithDetails = async () => {
  return axiosClient.get(`${base}/details/all`).then((response) => {
    return response.data;
  });
};

const getEntriesWithDetails = async () => {
  return axiosClient.get(`${base}/details/all`).then((response) => {
    return response.data;
  });
};

const getPlayerEntries = async (playerId) => {
  return axiosClient.get(`${base}/${playerId}`).then((response) => {
    return response.data;
  });
};

const addEntry = async (entry) => {
  return axiosClient.post(base, entry).then((response) => {
    return response.data;
  });
};

const updateEntry = async (id, entry) => {
  return axiosClient.put(`${base}/${id}`, entry).then((response) => {
    return response.data;
  });
};

const setEntryValid = async (id) => {
  return axiosClient.put(`${base}/${id}/mark-valid`).then((response) => {
    return response.data;
  });
};

const setEntryInvalid = async (id, reason, markedInvalidBy) => {
  return axiosClient
    .put(`${base}/${id}/mark-invalid`, {
      reason,
      markedInvalidBy,
    })
    .then((response) => {
      return response.data;
    });
};

const deleteEntry = async (id) => {
  return axiosClient.delete(`${base}/${id}`).then((response) => {
    return response.data;
  });
};

const importEntriesFromCsv = async (importData) => {
  return axiosClient.post("/import/entries", importData).then((response) => {
    return response.data;
  });
};

const validateEntriesFromCsv = async (validationData) => {
  return axiosClient
    .post("/import/validate-entries", validationData)
    .then((response) => {
      return response.data;
    });
};

const entryService = {
  getEntries,
  getAllEntriesWithDetails,
  getEntriesWithDetails,
  getPlayerEntries,
  addEntry,
  updateEntry,
  setEntryValid,
  setEntryInvalid,
  deleteEntry,
  importEntriesFromCsv,
  validateEntriesFromCsv,
};

export default entryService;
